import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import "../../cssfiles/homepage.css";
import MenuItem from "@mui/material/MenuItem";
import {
  createTheme,
  FormControl,
  Typography,
  ThemeProvider,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { ThemeContext } from "../Homepage";
import { useContext } from "react";
import InputLabel from "@mui/material/InputLabel";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";

export default function CustomDropDown({
  options,
  onChange,
  disabled,
  defaultValue,
  fontSize,
  width,
  name,
  displayEmpty,
  disabledOptions,
}) {
  const { theme } = useContext(ThemeContext);

  //const  timePeriod = ["Today","Yesterday","This Week","Last Week","This Month","Last Month","This Year","Last Year","Last 24 hours","Last 7 days","Last 30 days","Custom"];

  const [selectedValue, setSelectedValue] = useState(
    defaultValue !== null && defaultValue !== undefined ? defaultValue : "",
  );
  //const [dropdown_data, setdropdown_data] = useState(data);
  const [label, setLabel] = useState("");

  useEffect(() => {
    // if(selectedValue!==""){
    //     onChange(selectedValue)
    // }
    // else{
    //     onChange(defaultValue)
    // }
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setLabel("");
    //selected(event.target.value)
    onChange(event.target.value, event);
  };
  return (
    /*width for the form? sx={{width: width ? width : '224px'}} //width: width ? '100%' : '224px',*/
    <FormControl disabled={disabled != null ? disabled : false}>
      {/* <InputLabel id="yearSelect"  shrink={false} sx={{textAlign:"left",marginRight:"6px",fontSize:'12px', fontFamily:'Roboto',fontWeight:400,marginTop:"-6px",color:"var(--GreyVariation_2)" }}>{'year'}</InputLabel>  */}
      <Select
        variant="standard" /*disabled={disabled!=null?disabled:false}*/
        /*name="yearSelect" id="yearSelect" labelId="yearSelect"*/ inputlabel="year"
        /*  change this to only selected value value={(defaultValue && selectedValue == "") ? defaultValue : selectedValue}*/ value={
          selectedValue
        }
        onChange={handleChange}
        // defaultValue={defaultValue?defaultValue:"age"}
        style={{
          paddingBottom: "0px",
          paddingTop: "0px",
        }}
        name={name ? name : "yearSelect"}
        displayEmpty={displayEmpty ? displayEmpty : true}
        disableUnderline={disabled != null ? disabled : false}
        IconComponent={(props) => (
          <ExpandMoreOutlinedIcon
            style={{
              width: "16px",
              height: "16px",
              color:
                (disabled != null ? disabled : false) == true
                  ? theme === "light"
                    ? "#C1C1C1"
                    : "#3C3C3C"
                  : theme === "light"
                    ? "#3C3C3C"
                    : "#FFFFFF",
            }}
          />
        )}
        sx={{
          border: 0,
          width: width ? width : "224px",
          //height: '24px',
          bgcolor: "none",
          color: theme === "light" ? "#3C3C3C" : "#FFFFFF",
          fontSize: fontSize ? `${fontSize}px` : "16px",
          fontFamily: "Roboto",
          fontWeight: 400,
          textAlign: "left",
          borderRadius: 0,
          marginRight: "0px",
          "& .Mui-disabled": {
            borderBottom: "1px solid",
            borderBottomColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
            WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
          },
          "& .MuiSvgIcon-root": {
            fill:
              (disabled != null ? disabled : false) == true
                ? theme === "light"
                  ? "#C1C1C1"
                  : "#3C3C3C"
                : theme === "light"
                  ? "#3C3C3C"
                  : "#FFFFFF",
            //borderBottom: '1px solid var(--GreyVariation_2)',
          },
          // '& .MuiInputBase-root.MuiInput-root.MuiSelect-root.Mui-disabled':{color:"pink"},
          //':before': { borderBottom: '1px solid var(--GreyVariation_2)' ,borderBottomColor:(disabled!=null?disabled:false)==true?theme === 'light' ? '#C1C1C1' : '#3C3C3C' :'var(--GreyVariation_2)'},
          ":before": {
            borderBottom: `1px solid ${theme === "light" ? "#C7CED3" : "#FFFFFF"}`,
          },
          ":after": { borderBottom: "2px solid #008CD7" },
          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
            {
              border: 0,
              color: "red",
            },
          "& .MuiInputBase-input:focus": {
            color: "#008CD7",
            bgcolor: "none",
          },
          "& .MuiOutlinedInput-notchedOutline ": {
            width: "122.35px",
            //height:'24px',
            border: 0,
            padding: 0,
          },
          "& .MuiInputLabel-root": { display: "none", legend: "none" },
          "& .MuiSelect-select": {
            paddingTop: "0px",
            paddingBottom: "0px",
            marginTop: "0px",
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: theme === "light" ? "#C1C1C1" : "#3C3C3C",
            //WebkitBorderFillColor: themechange === 'light' ? '#C1C1C1' : '#3C3C3C',
          },
        }}
        InputLabelProps={{ shrink: false }}
        MenuProps={{
          disablePortal: true,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          PaperProps: {
            sx: {
              bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
              borderBottom: "2px solid #008CD7",
              borderRadius: 0,
              width: width ? width : "224px",
              maxWidth: "100%",
              boxShadow: "none",
              maxHeight: "250px",
              overflow: "auto",
              "&::-webkit-scrollbar": {
                width: "4px",
                height: "4px",
              },
              /* Track */
              "&::-webkit-scrollbar-track": {
                /*box-shadow: inset 0 0 5px grey,*/
                borderRadius: "0px",
                background: theme === "light" ? "#ffffff" : "#1e1e1e",
                margin: "4px 0px 4px 0px",
                // borderRight:'4px solid transparent',
                //     backgroundClip: 'padding-box',
              },
              /* Handle */
              "&::-webkit-scrollbar-thumb": {
                background: "#008CD7",
                borderRadius: "5px",
              },
              "& .MuiMenuItem-root.Mui-selected": {
                //background: "#005C8E",
                fontWeight: 700,
                color: "#000000",
              },
              "& .MuiMenuItem-root:hover": {
                backgroundColor: "#005C8E",
                color: "#000000",
              },
              color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
              "& .MuiList-root.MuiMenu-list": {
                padding: "4px 0px 4px 0px",
              },
            },
          },
        }}
      >
        {options?.map((val) => {
          return (
            <MenuItem
              sx={{
                fontSize: fontSize ? `${fontSize}px` : "16px",
                fontFamily: "Roboto",
                fontWeight: 400,
              }}
              value={val}
              disabled={
                disabledOptions && disabledOptions.length !== 0
                  ? disabledOptions.filter((value) => value === val)?.length !==
                    0
                    ? true
                    : false
                  : false
              }
            >
              <Typography
                sx={{ fontSize: fontSize ? `${fontSize}px` : "16px" }}
                noWrap
              >
                {val}
              </Typography>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}

// import React, { useEffect, useState } from "react";
// import "./Dashboard.css";
// import "../../cssfiles/homepage.css";
// import MenuItem from "@mui/material/MenuItem";
// import CustomTooltip from "./CustomTooltip";
// import { createTheme, FormControl,Typography, ThemeProvider } from "@mui/material";
// import Select, { SelectChangeEvent } from "@mui/material/Select";
// import { ThemeContext } from "../Homepage";
// import { useContext } from "react";
// import InputLabel from "@mui/material/InputLabel";
// import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

// export default function CustomDropDown({data,selected,disabled,defaultValue,fontSize,width,name,}) {
//   const { theme } = useContext(ThemeContext);

//   //const  timePeriod = ["Today","Yesterday","This Week","Last Week","This Month","Last Month","This Year","Last Year","Last 24 hours","Last 7 days","Last 30 days","Custom"];

//   const [selectedValue, setSelectedValue] = useState("");
//   //const [dropdown_data, setdropdown_data] = useState(data);
//   const [label, setLabel] = useState("");

//   useEffect(() => {
//     selected(selectedValue);
//   }, [selectedValue]);

//   const handleChange = (event) => {
//     setSelectedValue(event.target.value);
//     setLabel("");
//     //selected(event.target.value)
//   };

//   return (
//     <FormControl disabled={disabled!=null?disabled:false}>
//       {/* <InputLabel id="yearSelect"  shrink={false} sx={{textAlign:"left",marginRight:"6px",fontSize:'12px', fontFamily:'Roboto',fontWeight:400,marginTop:"-6px",color:"var(--GreyVariation_2)" }}>{'year'}</InputLabel>  */}
//       <Select
//         variant="standard"
//         disabled={disabled != null ? disabled : false}
//         name={name ? name : "yearSelect"}
//         id="yearSelect"
//         labelId="yearSelect"
//         inputlabel="year"
//         value={
//           defaultValue && selectedValue == "" ? defaultValue : selectedValue
//         }
//         onChange={handleChange}
//         // defaultValue={defaultValue?defaultValue:"age"}
//         style={{
//           paddingBottom: "0px",
//           paddingTop: "0px",
//         }}
//         sx={{
//           border: 0,
//           width: width ? width : "224px",
//           //height: '24px',
//           bgcolor: "none",
//           color: "var(--GreyVariation_2)",
//           fontSize: fontSize ? `${fontSize}px` : "18px",
//           fontFamily: "Roboto",
//           fontWeight: 400,
//           textAlign: "left",
//           borderRadius: 0,
//           marginRight: "0px",
//           "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
//             {
//               border: 0,
//             },
//           "& .MuiOutlinedInput-notchedOutline ": {
//             width: "122.35px",
//             //height:'24px',
//             border: 0,
//             padding: 0,
//           },
//           "& .MuiInputLabel-root": { display: "none", legend: "none" },
//           "& .MuiSelect-select": {
//             paddingTop: "0px",
//             paddingBottom: "0px",
//           },
//         }}
//         IconComponent={KeyboardArrowDownIcon}
//         InputLabelProps={{ shrink: false }}
//         MenuProps={{
//           PaperProps: {
//             sx: {
//               bgcolor: theme === "dark" ? "#3C3C3C" : "#C1C1C1",
//               borderBottom: "2px solid #008CD7",
//               borderRadius: 0,
//               boxShadow: "none",
//               maxHeight: "300px",
//               overflow: "auto",
//               width: width ? width : "224px",
//               whiteSpace: 'nowrap',
//               textOverflow: 'ellipsis',
//               //overflow: 'hidden',
//               color: theme === "dark" ? "#FFFFFF" : "#3C3C3C",
//             },
//           },
//         }}
//       >
//         {data.map((val) => {
//           return (
//               <MenuItem noWrap
//                 sx={{ fontSize: "16px", fontFamily: "Roboto", fontWeight: 400,width: width ? width : "224px",}}
//                 value={val}
//               >
//                 <div>
//                 {/* <CustomDropDown title={"hi"}></CustomDropDown> */}
//                   <Typography noWrap>{val}</Typography>
//                 </div>
//               </MenuItem>

//           );
//         })}
//       </Select>
//     </FormControl>
//   );
// }
